import { Alert } from '@common-web/index';
import { strings } from '@constants/strings';
import { isCP } from '@utils/app-utils';
import { AiOutlineExclamationCircle } from 'react-icons/ai';
import { useSelector } from 'react-redux';

const AccountStatusBanner = () => {
  const { info_completed } = useSelector((state) => state?.userData?.userInfo?.userProfile?.store || {});

  const getAlertType = () => {
    if (!info_completed) {
      return {
        type: 'warning',
        title: strings?.account_information_incomplete,
        message: strings?.make_sure_to_title_bank_iban,
        icon: <AiOutlineExclamationCircle color={'orange'} />,
        borderColor: 'var(--ant-blue-3)',
        bgColor: 'var(--ant-blue-1)',
        titleColor: 'var(--ant-gray-6)',
      };
    }

    return null;
  };

  if (isCP() || !getAlertType()) {
    return;
  }

  return (
    <Alert
      icon={getAlertType()?.icon}
      showIcon
      type={getAlertType()?.type}
      message={
        <span
          style={{ fontSize: 'var(--ant-font-size-heading-5)', fontWeight: 600, color: getAlertType()?.titleColor }}
        >
          {getAlertType()?.title}
        </span>
      }
      description={getAlertType()?.message}
      action={getAlertType()?.action}
      style={{
        '--ant-margin-xs': 0,
        '--ant-color-info-bg': getAlertType()?.bgColor,
        '--ant-color-info-border': getAlertType()?.borderColor,
        gap: 0,
        alignItems: 'center',
        position: 'sticky',
        top: 'calc(var(--ant-padding-lg) * -1)',
        zIndex: 9,
        margin: '0px 250px',
      }}
    />
  );
};

export default AccountStatusBanner;
